export default __webpack_public_path__ + "static/literature-reference-mobile-1eddfd10d6f85335a0cd3cca6985f2a6.png";